/**
 * Formatta un orario da hh:mm:ss a hh:mm
 * @param timeString - Stringa orario in formato hh:mm:ss o hh:mm
 * @returns Stringa orario in formato hh:mm o '-' se vuoto
 */
export const formatTime = (timeString: string | null | undefined): string => {
  if (!timeString) return '-';
  
  // Se è già nel formato hh:mm, restituiscilo così com'è
  if (timeString.length === 5 && timeString.includes(':')) {
    return timeString;
  }
  
  // Se è nel formato hh:mm:ss, rimuovi i secondi
  if (timeString.length === 8 && timeString.split(':').length === 3) {
    return timeString.substring(0, 5);
  }
  
  // Fallback: restituisci la stringa così com'è
  return timeString;
};

/**
 * Formatta un range di orari
 * @param startTime - Orario di inizio
 * @param endTime - Orario di fine
 * @param separator - Separatore tra gli orari (default: ' - ')
 * @returns Stringa formattata "hh:mm - hh:mm" o '-' se vuoto
 */
export const formatTimeRange = (
  startTime: string | null | undefined, 
  endTime: string | null | undefined, 
  separator: string = ' - '
): string => {
  const formattedStart = formatTime(startTime);
  const formattedEnd = formatTime(endTime);
  
  if (formattedStart === '-' || formattedEnd === '-') {
    return '-';
  }
  
  return `${formattedStart}${separator}${formattedEnd}`;
};

/**
 * Formatta ore decimali a formato hh:mm
 * Esempi:
 *   15.5 → "15:30"
 *   -15.333333 → "-15:20"
 *   0.25 → "0:15"
 * @param hours - Numero decimale rappresentante ore
 * @returns Stringa formattata "hh:mm"
 */
export const formatDecimalHours = (hours: number | null | undefined): string => {
  if (hours === null || hours === undefined || isNaN(hours)) {
    return '-';
  }

  const isNegative = hours < 0;
  const absHours = Math.abs(hours);
  const wholeHours = Math.floor(absHours);
  const decimalPart = absHours - wholeHours;
  const minutes = Math.round(decimalPart * 60);

  // Gestisci il caso in cui i minuti arrotondati diventano 60
  if (minutes === 60) {
    return `${isNegative ? '-' : ''}${wholeHours + 1}:00`;
  }

  const formattedMinutes = String(minutes).padStart(2, '0');
  return `${isNegative ? '-' : ''}${wholeHours}:${formattedMinutes}`;
};
